"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.i18n = exports.defaultLocale = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _locales = _interopRequireDefault(require("./locales"));

var defaultLocale = "en";
exports.defaultLocale = defaultLocale;

var i18n = function i18n(locales) {
  var i18nConfig = {
    lng: defaultLocale,
    fallbackLng: defaultLocale,
    lowerCaseLng: true,
    resources: locales || _locales["default"]
  };

  var newInstance = _i18next["default"].createInstance(i18nConfig, function (err) {
    if (err) return console.log("something went wrong loading i18next", err);
    return null;
  });

  return newInstance;
};

exports.i18n = i18n;
//# sourceMappingURL=i18n.js.map